import { createSlice } from '@reduxjs/toolkit';

export const couponList = createSlice({
  name: 'couponList',
  initialState: {
    data: [],
  },

  reducers: {
    setCouponList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCouponList } = couponList.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getCouponList = (state) => {
  return state.couponList.data;
};

export default couponList.reducer;
